import { isEmpty } from 'lodash'

import {
  LOADER,
  MODAL,
  BOOKING
} from '../../reduxs'

import apiService from '../apiService'
import { EXTEND_MEETING } from '../../helpers'

export const createIssue = (params, func = () => {}) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.postFormData('rest/v2/issue/create', params).then((res) => {
      if (res.status) {
        func(res)
        dispatch(LOADER.action.displayLoader(false))
      } else if (!res.status) {
        func(res)
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION createIssue', res)
      }
    })
  }
}

export const createBooking = (params, trackingSaveButton) => {
  return async (dispatch) => {
    try {
      dispatch(LOADER.action.displayLoader(true))
      const bookingResponse = await apiService.post('rest/v2/booking', params)
      dispatch(LOADER.action.displayLoader(false))
      
      if (bookingResponse.status) {
        dispatch(MODAL.action.openModalStatus(bookingResponse))
      } else {
        const { data: bookingData } = bookingResponse.data
        const isRepeatError = !isEmpty(bookingData) && !isEmpty(bookingData.availables)
        
        isRepeatError
          ? dispatch(MODAL.action.openCrashMeetingModal())
          : dispatch(MODAL.action.openModalStatus({ ...bookingResponse }))
      }

      trackingSaveButton()
    } catch (error) {
      console.error('ERROR createBooking', error)
    }
  }
}

export const updateBooking = (params) => {
  const { bookingId, ...payload } = params

  return async (dispatch) => {
    try {
      dispatch(LOADER.action.displayLoader(true))
      const bookingResponse = await apiService.patch(`rest/v2/booking/${bookingId}`, payload)
      dispatch(LOADER.action.displayLoader(false))
      
      if (bookingResponse.status) {
        dispatch(MODAL.action.openModalStatus(bookingResponse))
      } else {
        const { data: bookingData } = bookingResponse.data
        const isRepeatError = !isEmpty(bookingData) && !isEmpty(bookingData.availables)
  
        isRepeatError
          ? dispatch(MODAL.action.openCrashMeetingModal())
          : dispatch(MODAL.action.openModalStatus({ ...bookingResponse }))
      }
    } catch (error) {
      console.error('ERROR updateBooking', error)
    }
  }
}

export const getListAllBooking = (param, func) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))

    return apiService.get('rest/v2/getlist_booking', { ...param, showPrivateSubject: true }).then((res) => {
      if (res.status) {
        dispatch(saveListAllBooking(res.data))
        func()
        dispatch(LOADER.action.displayLoader(false))
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION getListAllBooking', res)
      }
    })
  }
}

export const deleteBooking = (param, func) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.post('rest/v1/delete_booking', param).then((res) => {
      if (res.status) {
        dispatch(MODAL.action.closeModalConfirm())
        func()
        dispatch(LOADER.action.displayLoader(false))
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION deleteBooking', res)
      }
    })
  }
}

export const endMeeting = (param, func) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.post('rest/v1/end_booking', param).then((res) => {
      if (res.status) {
        dispatch(MODAL.action.setSuccessOrderModal(true))
        dispatch(LOADER.action.displayLoader(false))
        func()
      } else if (!res.status) {
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION endMeeting', res)
      }
    })
  }
}

export const extendMeeting = (id, param, func = () => {}) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.put(`rest/V2/booking/${id}/extend`, param).then((res) => {
      if (res.status) {
        dispatch(MODAL.action.setSuccessOrderModal(true))
        dispatch(LOADER.action.displayLoader(false))
        func()
      } else if (!res.status) {
        dispatch(MODAL.action.setErrorModal(true, EXTEND_MEETING.ERROR_EXTEND))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION extendMeeting', res)
      }
    })
  }
}

export const getBookingCheckIn = (bookingId) => {
  return () => apiService.get('rest/v1/getdetail_booking', { bookingId, getAll: true })
}

export const checkInBooking = (params) => {
  return () => apiService.post('rest/v2/booking/check-in', params)
}

export const checkInAllBooking = (bookingId) => {
  return () => apiService.post(`rest/v2/booking/${bookingId}/check-in-all`)
}

export const saveListAllBooking = (data) => {
  return {
    type: BOOKING.actionType.SAVE_LIST_BOOKING,
    data
  }
}

export const clearListBooking = () => {
  return {
    type: BOOKING.actionType.CLEAR_LIST_BOOKING
  }
}
